import { Component, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DatepickerComponent } from 'ng2-datepicker';

@Component({
  selector: 'my-datepicker',
  templateUrl: './my-datepicker.component.html',
  styleUrls: ['./my-datepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MyDatepickerComponent),
      multi: true,
    },
  ],
})
export class MyDatepickerComponent extends DatepickerComponent {}
